module.exports = __webpack_public_path__ + "static/media/edamame-dumpling.4d9581b4.png";